<template>
  <v-menu
    v-model="menu"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <div class="demo" :style="{ backgroundColor: color }"></div>
      <v-text-field
        :label="field.label"
        v-model="color"
        v-on="on"
        prepend-inner-icon="colorize"
      >
      </v-text-field>
    </template>
    <v-color-picker :label="field.label" v-model="color"> </v-color-picker>
  </v-menu>
</template>

<script>
import { logState } from "../../classes/logging";

export default {
  name: "ColorField",
  props: ["entity", "value", "field"],
  data() {
    return {
      menu: false
    };
  },
  computed: {
    color: {
      get() {
        return this.entity[this.field.name];
      },
      set(value) {
        logState("Color", { color: "red" }, value);
        this.entity[this.field.name] = value;
      }
    }
  }
};
</script>

<style scoped>
.demo {
  float: left;
  width: 32px;
  height: 32px;
  margin: 8px 10px 8px 0;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
